import { compare } from '../content.js'
import Icon from '../components/Icon.jsx'

export default function Compare() {
  return (
    <section className="section alt" id="compare">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">{compare.eyebrow}</span>
          <h2>{compare.title}</h2>
        </div>
        <div className="table-wrap">
          <table className="compare">
            <thead>
              <tr><th>Feature</th>{compare.cols.map((c, i) => <th key={c} className={i ? '' : 'us'}>{c}</th>)}</tr>
            </thead>
            <tbody>
              {compare.rows.map(([feat, ...vals]) => (
                <tr key={feat}>
                  <td>{feat}</td>
                  {vals.map((v, i) => (
                    <td key={i} className={i ? '' : 'us'}>
                      {v ? <span className="yes" role="img" aria-label="Yes"><Icon name="check" size={16} /></span> : <span className="no" role="img" aria-label="No">–</span>}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="compare-extra"><Icon name="checkCircle" size={18} />{compare.extra}</p>
        <p className="source">{compare.source}</p>
        <div className="claims">
          {compare.claims.map((c) => (
            <article key={c.vs} className="claim">
              <span className="claim-vs">{c.vs}</span>
              <p>{c.text}</p>
            </article>
          ))}
        </div>
        <h3 className="replaces-title">{compare.replaces.title}</h3>
        <div className="replaces">
          {compare.replaces.groups.map((g) => (
            <div key={g.name} className="replaces-group">
              <h4>{g.name}</h4>
              <div className="chips">{g.tools.map((t) => <span key={t} className="chip">{t}</span>)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
